import { faCheckCircle, faPencil, faPlus, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton, HeadingItem, SplitCard } from 'components';
import { ReconcileReasonGrid } from 'components/verify-item';
import { TripContext } from 'contexts';
import React, { FC, Fragment, useContext } from 'react';
import { useOrderItemService } from 'services';
import { ReconcileReasonType } from 'services/enums';
import { LineItem, OrderItem, OrderItemChange } from 'services/types';
import { IconOptions } from "types";
import './item-quantity-card.scss';

type Props = {
    itemId: number,
    onClick: (title: string) => void
    onQuantityAdjusted: (customerPoNumber: string | null, quantity: number) => void
}

export const ItemQuantityCard: FC<Props> = ({ itemId, onClick, onQuantityAdjusted }) => {
    const tripContext = useContext(TripContext)
    const { isOrderItemChangeComplete } = useOrderItemService()

    let item: OrderItem = tripContext.orderItems.find(oi => oi.id == itemId) ?? {} as OrderItem
    let changes: OrderItemChange[] = tripContext.orderItemChanges.filter(cw => cw.orderItemId == itemId)
    const lineItem: LineItem = tripContext.lineItems.find(li => li.id == item.lineItemId) ?? {} as LineItem

    let headerIcon = (changes: OrderItemChange[]): IconOptions => {
        let isNotComplete: OrderItemChange[] = (changes && changes.filter(x => !isOrderItemChangeComplete(x))) ?? []
        let icon: IconOptions = isNotComplete.length > 0 ? { icon: faTimesCircle, color: '#EB5757', size: '2x' } : { icon: faCheckCircle, color: '#76AB21', size: '2x' }
        return icon
    }

    let countedQuantity = item.countedQuantity ?? item.shippedQuantity

    const calculateDeliveredQuanitity = (item: OrderItem) => {
        let orderItemChangeQuantity: number = calculateRefusalQuantity(changes)
        return item.countedQuantity - orderItemChangeQuantity
    }

    const calcMinValue = (item: OrderItem) => {
        const deliveredQty = calculateDeliveredQuanitity(item)
        return Math.abs(countedQuantity - deliveredQty)
    }

    const calculateRefusalQuantity = (changes: OrderItemChange[]) => {
        let refusals: OrderItemChange[] | undefined = changes.filter(change => change.reconcileReasonId != ReconcileReasonType.OverageKept && change.reconcileReasonId != ReconcileReasonType.Shortage)
        let sum = 0
        refusals.forEach(refusal => {
            sum += refusal.quantity
        })
        return sum
    }

    return (
        <div className={'card-material'}>
            {changes && changes.length > 0 ?
                <HeadingItem text={`PO: ${item.customerPoNumber ?? 'Unknown'}`} rightHandIcon={headerIcon(changes)} />
                :
                <Fragment>
                    {item.verifiedMethod != null ?
                        <HeadingItem text={`PO: ${item.customerPoNumber ?? 'Unknown'}`} rightHandIcon={{ icon: faCheckCircle, color: '#76AB21', size: '2x' }} />
                        :
                        <HeadingItem text={`PO: ${item.customerPoNumber ?? 'Unknown'}`} />
                    }
                </Fragment>
            }
            <div className={'item-qty-adjust-details'}>
                <div>Ordered: {item.orderedQuantity}</div>
                <div>Shipped: {item.shippedQuantity}</div>
                <div>UOM: {lineItem && lineItem.unitOfMeasure}</div>
            </div>
            <SplitCard
                id={item.id!}
                leftSideQty={calculateDeliveredQuanitity(item)}
                minValue={calcMinValue(item)}
                rightSideQty={countedQuantity}
                leftSideHeaderText={"Delivered"}
                rightSideHeaderText={"Counted Qty"}
                inputDelay={500}
                onQuantityAdjusted={(id, quantity) => onQuantityAdjusted(id as string | null, quantity)}
            />
            <div className={'item-qty-adjust-refusal-button'}>
                {calculateRefusalQuantity(changes) > 0 ?
                    <ActionButton
                        icon={faPencil}
                        iconSize={'1x'}
                        buttonText={'Edit Refusal'}
                        buttonColor={'#F2994A'}
                        buttonWidth={'110px'}
                        onClick={() => onClick('Edit Refusal')}
                    />
                    :
                    <ActionButton
                        icon={faPlus}
                        iconSize={'1x'}
                        buttonText={'Add Refusal'}
                        buttonColor={'#EB5757'}
                        buttonWidth={'110px'}
                        onClick={() => onClick('Add Refusal')}
                    />
                }
            </div>
            {changes && changes?.length > 0 &&
                <ReconcileReasonGrid
                    itemId={itemId}
                    countedQuantity={countedQuantity}
                    onQuantityAdjusted={onQuantityAdjusted} />
            }
        </div>
    )
}
